import { useTranslation } from 'react-i18next';
import { Clips } from '../../../assets/svgs/icons';
import styles from './styles.module.css';

export const AttachImageButton = ({ visible, onClick, disabled = false }) => {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <button
      type="button"
      className={styles.attachButton}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={styles.neonBorder} />
      <span className={styles.content}>
        <Clips color="#505050" width={16} height={16} />
        <span>{t('chatsocket.buttons.attach')}</span>
      </span>
    </button>
  );
};
